module.exports = __webpack_public_path__ + "static/img/chart1.0112cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart1.png
// module id = Aaer
// module chunks = 1